function generateStars(width, height, size, count, color) {
    let bm = game.add.bitmapData(width, height);
    bm.fill(0, 0, 0, 0);
    let sizes = [];
    for (let i = size; i > 0; i--) sizes.push(i);
    bm.ctx.fillStyle = color;
    bm.ctx.beginPath();
    for (let i = 0; i < count; i++) {
        let x = game.rnd.integerInRange(0, width);
        let y = game.rnd.integerInRange(0, height);
        bm.ctx.moveTo(x, y);
        bm.ctx.arc(x, y, game.rnd.weightedPick(sizes), 0, Math.PI*2);
    }
    bm.ctx.fill();
    return bm;
}

const BASE_STARS_SPEED = 0.05;
const BASE_STARS_ACCELERATION = 0.01;

export default class Stars {

    constructor(x,y,gameState, group) {
        this.gameState = gameState;
        this.x = x;
        this.y = y;
        this.starsSpeed = 0;

        this.layers = [
            {texture: "background", speed: 1, y: 0},
            {texture: generateStars(game.canvas.width, game.canvas.height, 1, 1000, "#cccccc"), speed: 2, y: 0},
            {texture: generateStars(game.canvas.width, game.canvas.height, 2, 100, "#cccc77"), speed: 4, y: 0},
            {texture: generateStars(game.canvas.width, game.canvas.height, 3, 10, "#ffff99"), speed: 8, y: 0},
        ];
        for (let l of this.layers) {
            l.sprites = [
                game.add.sprite(x, y + l.y, l.texture, 0, group),
                game.add.sprite(x + game.canvas.width, y + l.y, l.texture, 0, group)
            ];
        }
    }

    moveBack() {
        for (let l of this.layers.slice().reverse()) {
            l.sprites[0].parent.sendToBack(l.sprites[0]);
            l.sprites[1].parent.sendToBack(l.sprites[1]);
        }
    }

    update() {
        let relativeSpeed = this.gameState.paused ? 0 : this.gameState.relativeSpeed;
        if (this.starsSpeed < relativeSpeed) {
            let delta = Math.min(relativeSpeed - this.starsSpeed, BASE_STARS_ACCELERATION * game.time.physicsElapsedMS);
            this.starsSpeed += delta;
        } else if (this.starsSpeed > relativeSpeed) {
            let delta = Math.min(this.starsSpeed - relativeSpeed, BASE_STARS_ACCELERATION * game.time.physicsElapsedMS);
            this.starsSpeed -= delta;
        }
        for (let l of this.layers) {
            l.sprites[0].x -= this.starsSpeed * game.time.physicsElapsedMS * l.speed * BASE_STARS_SPEED;
            l.sprites[1].x -= this.starsSpeed * game.time.physicsElapsedMS * l.speed * BASE_STARS_SPEED;
            if (l.sprites[0].x < this.x-game.canvas.width) {
                l.sprites[0].x += 2*game.canvas.width;
            }
            if (l.sprites[1].x < this.x-game.canvas.width) {
                l.sprites[1].x += 2*game.canvas.width;
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/states/stars.js